/**
 * Walk tag groups — each tag stored as a slug in MongoDB,
 * displayed as a title-cased label in the UI.
 */
export const TAG_GROUPS = [
  {
    group: 'Difficulty & Pace',
    tags: ['easy', 'moderate', 'challenging', 'flat', 'hilly', 'steep', 'beginner-friendly', 'strenuous'],
  },
  {
    group: 'Duration',
    tags: ['under-1-hour', '1-2-hours', 'half-day', 'full-day', 'epic'],
  },
  {
    group: 'Fitness & Intensity',
    tags: ['fitness', 'high-mileage', 'leisurely', 'power-walk', 'training-route'],
  },
  {
    group: 'Vibe & Mood',
    tags: ['adventurous', 'romantic', 'solo', 'meditative', 'social', 'photogenic', 'off-the-beaten-path'],
  },
  {
    group: 'Who It\'s For',
    tags: ['dog-friendly', 'family-friendly', 'kid-friendly', 'senior-friendly', 'solo-traveler', 'first-time-visitor'],
  },
  {
    group: 'Terrain & Environment',
    tags: ['coastal', 'canyon', 'urban-grid', 'waterfront', 'hillside', 'tree-lined', 'rooftop-views', 'beachfront'],
  },
  {
    group: 'Time of Day',
    tags: ['sunrise', 'sunset', 'night-walk', 'golden-hour', 'midday'],
  },
  {
    group: 'Practical',
    tags: ['parking-easy', 'transit-accessible', 'shade-heavy', 'minimal-shade', 'restrooms-available', 'free'],
  },
];

/**
 * Convert a tag slug to a display label.
 * "dog-friendly" → "Dog Friendly"
 */
const LABEL_OVERRIDES = {
  '1-2-hours': '1-2 Hours',
  'under-1-hour': 'Under 1 Hour',
  'half-day': 'Half Day',
  'full-day': 'Full Day',
  'high-mileage': 'High Mileage',
  'off-the-beaten-path': 'Off the Beaten Path',
};

export default function tagLabel(slug) {
  if (!slug) return '';
  if (LABEL_OVERRIDES[slug]) return LABEL_OVERRIDES[slug];
  return slug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
